const NAME_DISALLOWED = /[^a-zA-Zа-яА-ЯёЁ\s]/g;

export function useFilterNameValue(value: string): string {
	return value.replace(NAME_DISALLOWED, '');
}
